import React, { createContext, useContext, ReactNode } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { NotificationProfile } from '../../types';
import {
  BaseStepperContextValue,
  BaseStepperProvider,
} from '../../shared/contexts/BaseStepperContext';

interface StepperContextValue extends BaseStepperContextValue {
  // Profile management (specific to ModifyAccountStepper)
  handleProfileChange: (event: SelectChangeEvent<number>) => void;
  setOriginalProfile?: (profile: NotificationProfile | null) => void;
  onNewProfileCreated?: () => void;
  onProfileSaved?: () => void;
  originalProfile: NotificationProfile | null;
  isNewProfile?: boolean; // Indicates if the profile is new
  setIsNewProfile?: (isNew: boolean) => void;
}

const StepperContext = createContext<StepperContextValue | undefined>(
  undefined
);

export const useStepperContext = (): StepperContextValue => {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error('useStepperContext must be used within a StepperProvider');
  }
  return context;
};

interface StepperProviderProps {
  children: ReactNode;
  value: StepperContextValue;
}

export const StepperProvider: React.FC<StepperProviderProps> = ({
  children,
  value,
}) => {
  return (
    <BaseStepperProvider value={value}>
      <StepperContext.Provider value={value}>
        {children}
      </StepperContext.Provider>
    </BaseStepperProvider>
  );
};
